// extracted by mini-css-extract-plugin
export default {"logIn-button":"logInButton_logIn-button__fJZPd"};